
    <fieldmagic-pill
      [content]="progress"
      [variant]="variant"
    >
    </fieldmagic-pill>
  